import React from "react";
import { Link } from "react-router-dom";
import { CONTACT_EMAIL, DEVELOPER_NAME } from "../data/apps";

const Footer = () => (
  <footer className="site-footer">
    <div className="container footer-inner">
      <div>
        © {new Date().getFullYear()} Northwind. Apps by {DEVELOPER_NAME}.
      </div>
      <div className="footer-links">
        <Link to="/privacy">Privacy Policy</Link>
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </div>
    </div>
  </footer>
);

export default Footer;
